import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IAccessibleViewService } from 'vscode/vscode/vs/workbench/contrib/accessibility/browser/accessibleView.service';
import { AccessibleViewAction } from 'vscode/vscode/vs/workbench/contrib/accessibility/browser/accessibleViewActions';
import { ITerminalService } from 'vscode/vscode/vs/workbench/contrib/terminal/browser/terminal.service';
import { TerminalChatContextKeys } from './terminalChat.js';
import { TerminalChatController } from './terminalChatController.js';

class TerminalInlineChatAccessibleViewContribution extends Disposable {
    constructor() {
        super();
        this._register(AccessibleViewAction.addImplementation(105, 'terminalInlineChat', accessor => {
            const accessibleViewService = accessor.get(IAccessibleViewService);
            const terminalService = accessor.get(ITerminalService);
            const controller = terminalService.activeInstance?.getContribution(TerminalChatController.ID) ?? undefined;
            if (!controller?.lastResponseContent) {
                return false;
            }
            const responseContent = controller.lastResponseContent;
            accessibleViewService.show({
                id: "terminal-chat" ,
                verbositySettingKey: "accessibility.verbosity.inlineChat" ,
                provideContent() { return responseContent; },
                onClose() {
                    controller.focus();
                },
                options: { type: "view"  }
            });
            return true;
        }, TerminalChatContextKeys.focused));
    }
}

export { TerminalInlineChatAccessibleViewContribution };
